import { defineComponent as r, createBlock as l, openBlock as a, unref as p, mergeProps as c, withCtx as i, createElementVNode as n } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconPlusInCircle",
  __name: "IconPlusInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (u, e) => (a(), l(p(s), c(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        n("path", { d: "M7.25 12A.75.75 0 0 1 8 11.25h3.25V8a.75.75 0 0 1 1.5 0v3.25H16a.75.75 0 0 1 0 1.5h-3.25V16a.75.75 0 0 1-1.5 0v-3.25H8A.75.75 0 0 1 7.25 12" }, null, -1),
        n("path", {
          "fill-rule": "evenodd",
          d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
